<template>
  <!-- search form area -->
  <section class="sec bg-light form-sec">
    <div class="container container-lg">
        <div class="search-form-area">
          <div class="row">
              <div class="col-sm-12 form-heading">
                  <h2 class="sec-title">FILTER THE FUNDERS</h2>
              </div>
              <div class="col-sm-12  form-all">
                <div class="form-all-in m-auto">
                  <form action="#">
                    <div class="row expanded">
                      <sector-drop-down
                        type='chart'
                        :withIcon="true">
                        <i class="icon icon-gear icon-left"></i>
                      </sector-drop-down>
                      <investor-type-drop-down
                          type='chart'
                          :withIcon="true">
                        <i class="icon icon-filter icon-left"></i>
                      </investor-type-drop-down>
                      <capital-type-drop-down
                        type='chart'
                        :withIcon="true"
                      >
                        <i class="icon icon-gear icon-left"></i>
                      </capital-type-drop-down>
                    </div>
                  </form>
                </div>
              </div>
            </div>
        </div>
      </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CapitalTypeDropDown from './dropdowns/CapitalTypeDropDown.vue'
import CountryDropDown from './dropdowns/CountryDropDown.vue'
import SectorDropDown from './dropdowns/SectorDropDown.vue'
import InvestorTypeDropDown from './dropdowns/InvestorTypeDropDown.vue'

export default {
  name: "SearchBar",
  components: {
    'capital-type-drop-down': CapitalTypeDropDown,
    'country-drop-down': CountryDropDown,
    'sector-drop-down': SectorDropDown,
    'investor-type-drop-down': InvestorTypeDropDown
  },
  computed: {
    ...mapGetters({
      results: "results",
      sectors: "sectors",
      capitalTypes: "capitalTypes",
      providerTypes: "providerTypes",
      countries: "countries",
    })
  },
  methods: {},
  mounted(){

     $('.jquerydropdown').multiselect();

     $('.dropdown-menu').click(function(e) {
       e.stopPropagation();
     });

     $(function () {
       $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').tooltip();
     })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBars/IndexSearchBar.vue